import { useEffect } from 'react'

import { basicKeybindSkips } from 'components/deckPage/modals/KeybindsOverlay'

const useKeylistener = (onKeydown: (e: KeyboardEvent) => void, paramtersList = new Array<any>()) => {
  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (basicKeybindSkips(e)) return

      onKeydown(e)
    }

    document.addEventListener('keydown', handleKeydown)

    return () => {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, paramtersList)
}

export default useKeylistener
